<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import settings from '@/config/settings';

export default {
  name: 'App',
  watch: {
    $route() {
      document.title = settings.platformName;
    }
  },
  mounted() {
    document.title = settings.platformName;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
body {
  margin: 0 !important;
}
</style>